import { AxiosResponse } from 'axios';
import { getNameRegister } from 'civil-status/components/shared/list-register';
import { MunicipalNumberList } from 'civil-status/view-models/municipal-number';
import { HttpResponse, HttpResponseListPayload } from 'shell/models/http-response';
import { MunicipalNumberResponse } from 'shell/models/municipal-numer';

export const transformerResearchMunicipalNumberList = (
  response: AxiosResponse<HttpResponse<Array<MunicipalNumberResponse>>>
): Array<MunicipalNumberList> => {
  const listResponse = (response.data?.payload || []) as unknown as Array<MunicipalNumberResponse>;
  const totalCount = ((response.data as unknown as HttpResponseListPayload<MunicipalNumberResponse>)
    ?.totalRows || 0) as number;

  return listResponse.map((item) => ({
    id: item.idRichiesta || undefined,
    date: item.dataRichiesta || '',
    idAnsc: item.idAnsc || undefined,
    number: item.numero || undefined,
    operator: item.operatore || '',
    register: getNameRegister(item.registro || ''),
    state: item.stato || '',
    year: item.anno || undefined,
    totalCount,
    idPrenotazioneAtti: item.idPrenotazioneAtti,
    numeroAttoComunale: item.numeroAttoComunale,
  }));
};
